{
  "location_not_available": "Ubicación no disponible",
  "map": {
    "title": "Mapa",
    "navigation_title": "Mapa"
  }
}
